<template>
  <div>
    <div v-show="!Trabajando">
      <div v-show="Items && Items.length" class="table-responsive">
        <table class="table table-hover">
          <thead>
            <tr>
              <th scope="col" v-for="mapa of MapaColumnas" :key="mapa.clave">
                {{ mapa.cabecera ? mapa.cabecera : mapa.clave }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="item of Items"
              :key="item.id"
              @click="clickItem(item)"
              role="button"
            >
              <!-- Si existe una transformación se transforma, sino se renderiza el valor común -->
              <td v-for="mapa of MapaColumnas" :key="mapa.clave">
                <!-- Valor transformado -->
                <span v-if="mapa.transformacion">
                  <!-- Esta forma de aplicar el filtro a través de otro filtro, asegura que se obtenga una alta performance y no se realice la operación muchas veces -->
                  {{
                    item[mapa.clave]
                      | aplicar(
                        mapa.transformacion.filtro,
                        mapa.transformacion.argumentos
                      )
                  }}
                </span>
                <!-- Valor sin transformar -->
                <span v-else>
                  {{ item[mapa.clave] }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
        <Paginacion
          ref="paginacion"
          :cantidad="cantidad"
          :cantidadPorPagina="cantidadPorPagina"
          v-on:pagina-cambiada="paginaCambiada"
        />
      </div>
      <div v-show="!Items || !Items.length">
        <div class="alert alert-primary" role="alert">
          No se encontraron elementos
        </div>
      </div>
    </div>
    <!-- Trabajando -->
    <div v-show="Trabajando" class="spinner-border m-5" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>
<script>
import Paginacion from "../../Paginacion";
import { Util } from "../../../util";

const EVENTO_ITEM_ELEGIDO = "evento-item-elegido";
const EVENTO_LISTA_CARGADA = "lista-cargada";

export default {
  components: {
    Paginacion
  },
  props: {
    /** Objeto con datos de busqueda para filtrar */
    busqueda: Object,
    cantidadPorPagina: Number,
    /** Si está en verdadero, no se realizarán cargas automáticas.
    Ejemplo en el mounted hook o cuando cambia la búsqueda */
    cargaManual: Boolean,
    columnas: Array,
    facade: Function
  },
  data() {
    return {
      cantidad: 0,
      items: [],
      // Mantiene los ajustes que serán aplicados a las columnas
      mapaColumnas: [],
      /** Indicador de que se está trabajando, al comunicarse con el servidor */
      trabajando: true
    };
  },
  computed: {
    Items() {
      return this.items;
    },
    MapaColumnas() {
      return this.mapaColumnas;
    },
    Trabajando() {
      return this.trabajando;
    }
  },
  watch: {
    columnas(valor) {
      this.ajustarColumnas(valor);
    },
    busqueda() {
      if (!this.cargaManual) {
        this.recargar();
      }
    }
  },
  methods: {
    EventoRecargar(busqueda) {
      this.recargar(busqueda);
    },
    ajustarColumnas(ajustes) {
      // Si se pasaron ajustes utilizarlos
      if (ajustes) {
        this.mapaColumnas = ajustes;
      }
      // No se pasaron ajustes, generar mapa
      else {
        this.mapaColumnas = Object.keys(this.items[0]).map(key => {
          return {
            clave: key,
            // Poner en mayúscula la primera letra y cambiar "_" por espacios
            cabecera:
              key.slice(0, 1).toUpperCase() + key.replace(/_/g, " ").slice(1)
          };
        });
      }
    },
    cargar(busqueda = this.busqueda) {
      this.trabajando = true;

      // Parámetros de paginación
      const desde = this.$refs.paginacion.Desde;
      const hasta = this.$refs.paginacion.Hasta;

      this.facade
        .getListWithFilter({ desde, hasta, busqueda })
        .then(respuesta => {
          this.items = respuesta.data;

          // Ajustar columnas cuando los datos están cargados
          // De esta forma el ajuste automático no fallará
          if (!this.mapaColumnas.length) {
            this.ajustarColumnas(this.columnas);
          }

          this.$emit(EVENTO_LISTA_CARGADA, this.items);
        })
        .catch(error => {
          console.error(error);
        })
        .finally(() => {
          this.trabajando = false;
        });
    },
    clickItem(item) {
      this.$emit(EVENTO_ITEM_ELEGIDO, item);
    },
    // Cuando ya fue eliminado en el servidor
    eliminado(item) {
      // Se busca por ID porque el elemento pasado puede ser una copia profunda
      const indice = this.items.findIndex(i => i.id == item.id);

      // Si se encontró el elemento buscado
      if (indice != -1) Util.eliminarEn(this.items, indice);
    },
    // Este método es llamado cuando un item fue guardado en el servidor
    // el objeto que viene ya tiene id y datos completados por el servidor
    // Puede haber sido creado o editado
    guardado(item) {
      const indice = this.items.findIndex(i => i.id == item.id);

      // Si el indice es != -1 es porque se encontró
      if (indice != -1) {
        // Como se encontró, fue una edición, reemplazar el viejo por el nuevo
        this.items[indice] = item;

        // Es necesario que se reasigne el arreglo para que Vue pueda detectar el cambio y renderice correctamente
        this.items = Util.copiaProfunda(this.items);
      }
      // Es una creación, agregar a la lista localmente
      else {
        this.items.unshift(item);
      }
    },
    paginaCambiada() {
      this.cargar();
    },
    recargar(busqueda = this.busqueda) {
      this.trabajando = true;
      this.items = [];

      this.facade.countWithFilter({ busqueda }).then(respuesta => {
        this.cantidad = respuesta.data;

        if (this.cantidad > 0) this.cargar(busqueda);
        else this.trabajando = false;
      });
    }
  },
  mounted() {
    // Cargar el mapa de columnas solo si hay ajustes especificados
    if (this.columnas && (!this.mapaColumnas || !this.mapaColumnas.length)) {
      this.ajustarColumnas(this.columnas);
    }

    if (!this.cargaManual) {
      this.recargar();
    }
  },
  filters: {
    aplicar: function(valor, filtroAplicado, argumentos = null) {
      if (!filtroAplicado) return valor;
      else {
        if (argumentos)
          // El operador "..." saca los argumentos del arreglo y los pasa inviduales
          return filtroAplicado(valor, ...argumentos);
        else return filtroAplicado(valor);
      }
    }
  }
};
</script>
